<script>
export default {
  name: 'ResendContainer',
  props: {
    timeout: {
      type: Number,
      default: 60,
    },
    visible: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      countdown: 0,
      intervalId: null,
    }
  },
  computed: {
    shouldDisplayCounter() {
      return this.countdown > 0
    },
    shouldDisplayResendButton() {
      return this.countdown === 0
    },
    countdownFormatted() {
      const minutes = Math.floor(this.countdown / 60)
      const seconds = this.countdown % 60

      const formattedMinutes = String(minutes).padStart(2, '0')
      const formattedSeconds = String(seconds).padStart(2, '0')

      return `${formattedMinutes}:${formattedSeconds}`
    },
  },
  watch: {
    visible(newValue) {
      if (newValue) {
        this.startCountdown()
      } else {
        this.stopCountdown()
      }
    },
  },
  created() {
    if (this.visible) {
      this.startCountdown()
    }
  },
  beforeDestroy() {
    this.stopCountdown()
  },
  methods: {
    startCountdown() {
      if (this.intervalId) {
        return // Avoid creating a new interval if one is already running
      }

      this.countdown = this.timeout

      this.intervalId = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown -= 1
        } else {
          this.stopCountdown()
        }
      }, 1_000)
    },
    stopCountdown() {
      if (this.intervalId) {
        clearInterval(this.intervalId)

        this.intervalId = null
      }
    },
    onResend() {
      this.$emit('resend')
      this.stopCountdown()
      this.startCountdown()
    },
  },
}
</script>

<template>
  <div
    v-if="visible"
    class="resend-container"
    :class="{ 'is-activated-resend': shouldDisplayResendButton }"
  >
    {{ $t('otp_not_receive_code') }}
    <div class="content-resend__body">
      <template v-if="shouldDisplayCounter">
        {{ $t('onboarding_verification_resend') }}
        {{ countdownFormatted }}
      </template>
      <template v-else>
        <div class="content-resend__body__cta" @click="onResend">
          {{ $t('onboarding_verification_resend_text') }}
        </div>
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.resend-container {
  display: flex;
  flex-direction: row;
  gap: 4px;

  &.is-activated-resend {
    flex-direction: column;
  }

  .content-resend__body__cta {
    color: var(--tamara-color-accent-purple-dark);
    text-decoration: underline;
    text-underline-offset: 4px;
    cursor: pointer;
  }
}
</style>
